import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PalletisingConfigurationService } from '../services/palletising.configuration.service';
import { IFormStackParam, IStackParam } from '../types';

@Component({
	selector: 'app-create-update-stack-param',
	templateUrl: './create-update-stack-param.html',
	styleUrls: ['./create-update-stack-param.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateUpdateStackParamDialogComponent implements OnInit {
	@Output() saved = new EventEmitter<void>();
	public form: FormGroup;
	public isCreatingStackParam: boolean;
	public stackParam: IStackParam;
	public headingKey: string;
	public constructor(
		@Inject(MAT_DIALOG_DATA) public data: IStackParam | null,
		public dialogRef: MatDialogRef<CreateUpdateStackParamDialogComponent>,
		private service: PalletisingConfigurationService,
		private fb: FormBuilder,
	) {
		this.stackParam = data || this.defaultStackParam;
		this.isCreatingStackParam = data === null;
	}

	public ngOnInit(): void {
		this.initializeForm();
	}

	private initializeForm(): void {
		this.headingKey = this.isCreatingStackParam ? 'masterdata.palletising.configuration.stacking.createLabel' : 'masterdata.palletising.configuration.stacking.updateLabel';
		this.form = this.fb.group({
			maxHeightAfter: [this.stackParam.maxHeightAfter, [Validators.required, Validators.min(1), Validators.max(10000)]],
			maxWeightElement: [this.stackParam.maxWeightElement, [Validators.required, Validators.min(1), Validators.max(10000)]],
			toHeight: [this.stackParam.toHeight, [Validators.required, Validators.min(1), Validators.max(10000)]],
		});
		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value: IFormStackParam) => {
			this.stackParam.maxHeightAfter = Number(value.maxHeightAfter);
			this.stackParam.maxWeightElement = Number(value.maxWeightElement);
			this.stackParam.toHeight = Number(value.toHeight);
		});
	}

	public onCancel(): void {
		this.dialogRef.close();
	}

	public onCreateUpdateSave(): void {
		if (this.isCreatingStackParam) {
			this.service.onCreateUpdateSave(this.stackParam);
		}
		this.dialogRef.close();
		this.service.updateConfiguration();
	}

	public get controls() {
		return this.form.controls;
	}

	private get defaultStackParam(): IStackParam {
		return {
			maxHeightAfter: 10_000,
			maxWeightElement: 10_000,
			toHeight: 10_000,
			type: {
				self: '/palletising/configuration-stacking-rule-types/height',
			},
		};
	}
}
